module.exports = __webpack_public_path__ + "static/media/3.08724562.JPG";